export default {
    allowCopy: {
        type: [Boolean, Object],
        default: undefined
    }, 
    altRowTemplate: {
        type: [String, Function],
        default: undefined
    }, 
    autoBind: {
        type: Boolean,
        default: undefined
    }, 
    columnResizeHandleWidth: {
        type: Number,
        default: undefined
    }, 
    columns: {
        type: Array,
        default: undefined
    }, 
    columnMenu: {
        type: [Boolean, Object],
        default: undefined
    }, 
    dataSource: {
        type: [Object, Array],
        default: undefined
    }, 
    detailTemplate: {
        type: [String, Function],
        default: undefined
    }, 
    editable: {
        type: [Boolean, Object, String],
        default: undefined
    }, 
    excel: {
        type: Object,
        default: undefined
    }, 
    filterable: {
        type: [Boolean, Object],
        default: undefined
    }, 
    groupable: {
        type: [Boolean, Object],
        default: undefined
    }, 
    height: {
        type: [Number, String],
        default: undefined
    }, 
    messages: {
        type: Object,
        default: undefined
    }, 
    mobile: {
        type: [Boolean, String],
        default: undefined
    }, 
    navigatable: {
        type: Boolean,
        default: undefined
    }, 
    noRecords: {
        type: [Boolean, Object],
        default: undefined
    }, 
    pageable: {
        type: [Boolean, Object],
        default: undefined
    }, 
    pdf: {
        type: Object,
        default: undefined
    }, 
    persistSelection: {
        type: Boolean,
        default: undefined
    }, 
    reorderable: {
        type: Boolean,
        default: undefined
    }, 
    resizable: {
        type: Boolean,
        default: undefined
    }, 
    rowTemplate: {
        type: [String, Function],
        default: undefined
    }, 
    scrollable: {
        type: [Boolean, Object],
        default: undefined
    }, 
    selectable: {
        type: [Boolean, String],
        default: undefined
    }, 
    sortable: {
        type: [Boolean, Object],
        default: undefined
    }, 
    toolbar: {
        type: [String, Function, Array],
        default: undefined
    }, 

    // Events
    beforeEdit: {
        type: Function,
        default: undefined
    },  
    cancel: {
        type: Function,
        default: undefined
    },  
    cellClose: {
        type: Function,
        default: undefined
    },  
    change: {
        type: Function,
        default: undefined
    },  
    columnHide: {
        type: Function,
        default: undefined
    },  
    columnMenuInit: {
        type: Function,
        default: undefined
    },  
    columnMenuOpen: {
        type: Function,
        default: undefined
    },  
    columnReorder: {
        type: Function,
        default: undefined
    },  
    columnResize: {
        type: Function,
        default: undefined
    },  
    columnShow: {
        type: Function,
        default: undefined
    },  
    dataBinding: {
        type: Function,
        default: undefined
    },  
    dataBound: {
        type: Function,
        default: undefined
    },  
    detailCollapse: {
        type: Function,
        default: undefined
    },  
    detailExpand: {
        type: Function,
        default: undefined
    },  
    detailInit: {
        type: Function,
        default: undefined
    },  
    edit: {
        type: Function,
        default: undefined
    },  
    excelExport: {
        type: Function,
        default: undefined
    },  
    filter: {
        type: Function,
        default: undefined
    },  
    group: {
        type: Function,
        default: undefined
    },  
    groupCollapse: {
        type: Function,
        default: undefined
    },  
    groupExpand: {
        type: Function,
        default: undefined
    },  
    page: {
        type: Function,
        default: undefined
    },  
    pdfExport: {
        type: Function,
        default: undefined
    },  
    filterMenuInit: {
        type: Function,
        default: undefined
    },  
    filterMenuOpen: {
        type: Function,
        default: undefined
    },  
    remove: {
        type: Function,
        default: undefined
    },  
    save: {
        type: Function,
        default: undefined
    },  
    saveChanges: {
        type: Function,
        default: undefined
    },  
    sort: {
        type: Function,
        default: undefined
    },  
    columnLock: {
        type: Function,
        default: undefined
    },  
    columnUnlock: {
        type: Function,
        default: undefined
    },  
    navigate: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-grid-vue-wrapper/src/KendoGrid/GridProps.js